import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NavbarState } from "./navbar.state";

export const NavbarSelectorFactory = createFeatureSelector<NavbarState>('navbar')


export const selectTheme = createSelector(
  NavbarSelectorFactory,
  state => state.theme
)